import { createSlice } from "@reduxjs/toolkit";
import { resetAll } from "./baseSlice";
import { toast } from "react-toastify";
import intl from "../../i18n/intl";

const initialState = {
  uploading: false,
  success: false,
  error: null,
  progress: null,
  details: null,
};

const customIntl = intl();

const uploadSlice = createSlice({
  name: "uploads",
  initialState,
  extraReducers: (builder) => builder.addCase(resetAll, () => initialState),
  reducers: {
    uploadRequest: (state, action) => {
      state.uploading = {
        ...state.uploading,
        [action.payload.file.name]: true,
      };
      state.success = false;
      state.error = null;
      state.progress = {
        ...state.progress,
        [action.payload.file.name]: 0,
      };
      state.details = {
        ...state.details,
        [action.payload.file.name]: null,
      };
    },
    uploadProgress: (state, action) => {
      state.progress = {
        ...state.progress,
        [action.payload.file]: action.payload.progress,
      };
    },
    uploadSuccess: (state, action) => {
      state.uploading = {
        ...state.uploading,
        [action.payload.file]: false,
      };
      state.success = true;
      state.progress = {
        ...state.progress,
        [action.payload.file]: 100,
      };
      state.details = {
        ...state.details,
        [action.payload.file]: action.payload.response,
      };
      toast.success(customIntl.formatMessage({ id: "file_upload_success" }));
    },
    uploadFailure: (state, action) => {
      state.uploading = false;
      state.error = {
        ...state.error,
        [action.payload.file]: {
          status: action.payload.status,
          response: action.payload.response,
        },
      };
      state.progress = {
        ...state.progress,
        [action.payload.file]: 0,
      };
      if (action.payload.status === 413) {
        toast.error(customIntl.formatMessage({ id: "upload_size_error" }));
      } else {
        toast.error(customIntl.formatMessage({ id: "upload_error" }));
      }
    },
    resetUpload: (state) => {
      state.uploading = false;
      state.success = false;
      state.error = null;
      state.progress = null;
      state.details = null;
    },
  },
});

export const {
  uploadRequest,
  uploadProgress,
  uploadSuccess,
  uploadFailure,
  resetUpload,
} = uploadSlice.actions;
export default uploadSlice.reducer;
